import { Button, Col, Result, Row } from 'antd';
import * as React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CSUserProfile } from '../../models/csuser-profile-interface';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import { RoleQueries } from '../../queries/roles-query';
import EditUserCard from './components/EditUserCard';
import UserSelectionCard from './components/UserSelectionCard';

function ManageUsersPage() {
  const userList = CustomerServiceQueries.useUserList();
  const roleList = RoleQueries.useRolesList();
  const [selectedUser, setSelectedUser] = useState<CSUserProfile>();

  React.useEffect(() => {
    userList.refetch();
  }, [])

    return (
      <>
        <UserSelectionCard
          userList={userList.data}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
        />
      </>
    );
}

export default ManageUsersPage;
